import React from "react";
import Moment from "react-moment";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useRead from "../../../hooks/useRead";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../../components/table/Table";
import RoundedContainer from "../../../components/containers/RoundedContainer";

const EmployeeSalaryList = () => {
  const navigate = useNavigate();

  const { id, username } = useParams();
  const [searchParams] = useSearchParams();
  const source = searchParams.get("source");

  const { list } = useRead({
    url: "getEmployeeSalary",
    initialData: {
      company_employee_id: id,
    },
  });

  const handleNavigateToEmployeeDetail = (id, username, salaryData) => {
    navigate(
      `/employee-salary/${id}/${username}/edit-salary/${salaryData?.salary_id}?source=${source || ""}`,
      {
        state: salaryData,
      }
    );
  };

  return (
    <>
      {list.isLoading ? (
        <p className="text-center text-gray-500 mt-14 text-2xl">Loading.....</p>
      ) : (
        <>
          {list.data?.data?.length > 0 ? (
            <RoundedContainer className={"mx-4"}>
              <div className="max-w-full overflow-x-auto">
                <Table className="table-auto w-full">
                  <TableHead>
                    <TableHeaderCell className="w-1/6 min-w-[160px] text-lg font-semibold">
                      Sr.No
                    </TableHeaderCell>
                    <TableHeaderCell className="w-1/6 min-w-[160px] text-lg font-semibold">
                      Annual CTC
                    </TableHeaderCell>
                    <TableHeaderCell className="w-1/6 min-w-[160px] text-lg font-semibold">
                      Monthly Pay
                    </TableHeaderCell>
                    <TableHeaderCell className="w-1/6 min-w-[160px] text-lg font-semibold">
                      Effect From
                    </TableHeaderCell>
                    <TableHeaderCell className="w-1/6 min-w-[160px] text-lg font-semibold">
                      Effect Till
                    </TableHeaderCell>
                  </TableHead>
                  <TableBody>
                    {list.data?.data?.map((salaryData, idx) => {
                      const { annual_ctc, monthly_ctc, from_date, to_date } =
                        salaryData;
                      return (
                        <TableRow
                          key={salaryData.salary_id || idx}
                          onClick={() =>
                            handleNavigateToEmployeeDetail(
                              id,
                              username,
                              salaryData
                            )
                          }
                          className="cursor-pointer"
                        >
                          <TableCell className="text-center text-dark font-medium text-base">
                            {idx + 1}
                          </TableCell>
                          <TableCell className="text-center text-dark font-medium text-base">
                            {annual_ctc}
                          </TableCell>
                          <TableCell className="text-center text-dark font-medium text-base">
                            {monthly_ctc}
                          </TableCell>
                          <TableCell className="text-center text-dark font-medium text-base">
                            <Moment unix format="ll">
                              {Number(from_date)}
                            </Moment>
                          </TableCell>
                          <TableCell className="text-center text-dark font-medium text-base">
                            {to_date === null ||
                            to_date === undefined ||
                            to_date === 0 ||
                            to_date === "0" ||
                            to_date === "" ? (
                              "---"
                            ) : (
                              <Moment unix format="ll">
                                {Number(to_date)}
                              </Moment>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </div>
            </RoundedContainer>
          ) : (
            <p className="text-gray-500 text-2xl text-center mt-10">
              No Data Found
            </p>
          )}
        </>
      )}
    </>
  );
};

export default EmployeeSalaryList;
